<lib-form-field-container
    [isOptional]="isOptionalOverride"
    [kind]="FormContainerKind.Switch">

    <ng-content label select="[label]"></ng-content>
    <ng-content supportingText select="[supportingText]"></ng-content>

    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">
            {{ formControl.value ? 'Selected' : 'Not selected' }}
        </div>
    </ng-container>
    <div class="v3">
        @if (isLoading) {
            <div class="sb-form-field-text-skeleton sb-form-field-text-skeleton-sm"></div>
        } @else {
            <mat-slide-toggle #switch
                [id]="formFieldID"
                                [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                                                [attr.aria-label]="ariaLabel || null"
                                                [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
                                [attr.aria-required]="formControl.isRequired"
                [formControl]="viewControl"
                [disableRipple]="true"
                [attr.data-sb-qa]="qaTag"
                (click)="Clicked()"
                (change)="ChangeEvent($event)">
            </mat-slide-toggle>
        }
    </div>

</lib-form-field-container>
